module.exports = __webpack_public_path__ + "static/img/Yummy-Recipe.a5c0378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse/Yummy-Recipe.jpg
// module id = 1563
// module chunks = 0